function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#90DFAA"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CED5E0"
    },
    d: "M388,410.7H120c-1.7,0-3-1.4-3-3V100.4c0-1.7,1.4-3,3-3h268c1.7,0,3,1.4,3,3v307.3 C391,409.3,389.7,410.7,388,410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M117,109.4v289.2c0,6.7,5.4,12,12,12h214v-36c0-6.6,5.4-12,12-12h36V109.4c0-6.7-5.4-12-12-12H129 C122.3,97.3,117,102.7,117,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M343,410.7l48-48h-36c-6.6,0-12,5.4-12,12V410.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.3,
    y: 110.8,
    style: {
      fill: "#CED5E0"
    },
    width: 16.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 82.3,
    style: {
      fill: "#324A5E"
    },
    width: 10.1,
    height: 32.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.6,
    y: 110.8,
    style: {
      fill: "#CED5E0"
    },
    width: 16.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.6,
    y: 82.3,
    style: {
      fill: "#324A5E"
    },
    width: 10.1,
    height: 32.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 110.8,
    style: {
      fill: "#CED5E0"
    },
    width: 16.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.9,
    y: 82.3,
    style: {
      fill: "#324A5E"
    },
    width: 10.1,
    height: 32.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.3,
    y: 110.8,
    style: {
      fill: "#CED5E0"
    },
    width: 16.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.3,
    y: 82.3,
    style: {
      fill: "#324A5E"
    },
    width: 10.1,
    height: 32.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.6,
    y: 110.8,
    style: {
      fill: "#CED5E0"
    },
    width: 16.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.6,
    y: 82.3,
    style: {
      fill: "#324A5E"
    },
    width: 10.1,
    height: 32.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 110.8,
    style: {
      fill: "#CED5E0"
    },
    width: 16.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.9,
    y: 82.3,
    style: {
      fill: "#324A5E"
    },
    width: 10.1,
    height: 32.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.3,
    y: 110.8,
    style: {
      fill: "#CED5E0"
    },
    width: 16.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.3,
    y: 82.3,
    style: {
      fill: "#324A5E"
    },
    width: 10.1,
    height: 32.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.6,
    y: 110.8,
    style: {
      fill: "#CED5E0"
    },
    width: 16.1,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.6,
    y: 82.3,
    style: {
      fill: "#324A5E"
    },
    width: 10.1,
    height: 32.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M177,214.4h-31.1c-4.1,0-7.5-3.4-7.5-7.5v-31.1c0-4.1,3.4-7.5,7.5-7.5H177c4.1,0,7.5,3.4,7.5,7.5 V207C184.4,211.1,181.1,214.4,177,214.4z M146.4,206.5h30.2v-30.2h-30.2V206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M177,288.7h-31.1c-4.1,0-7.5-3.4-7.5-7.5v-31.1c0-4.1,3.4-7.5,7.5-7.5H177c4.1,0,7.5,3.4,7.5,7.5 v31.1C184.4,285.3,181.1,288.7,177,288.7z M146.4,280.7h30.2v-30.2h-30.2V280.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M177,362.9h-31.1c-4.1,0-7.5-3.4-7.5-7.5v-31.1c0-4.1,3.4-7.5,7.5-7.5H177c4.1,0,7.5,3.4,7.5,7.5 v31.1C184.4,359.5,181.1,362.9,177,362.9z M146.4,355h30.2v-30.2h-30.2V355z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M159.5,198.3c0.7,0.9,1.7,1.5,2.9,1.6c0.1,0,0.2,0,0.3,0c1.1,0,2.1-0.4,2.8-1.2l41.1-41.1 c1.6-1.6,1.6-4.1,0-5.6c-1.6-1.6-4.1-1.6-5.6,0l-37.9,37.9l-5.6-7.7c-1.3-1.8-3.8-2.2-5.5-0.9c-1.8,1.3-2.1,3.8-0.9,5.5 L159.5,198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M201,226.2l-37.9,37.9l-5.6-7.7c-1.3-1.8-3.8-2.2-5.5-0.9c-1.8,1.3-2.1,3.8-0.9,5.5l8.4,11.4 c0.7,0.9,1.7,1.5,2.9,1.6c0.1,0,0.2,0,0.3,0c1.1,0,2.1-0.4,2.8-1.2l41.1-41.1c1.6-1.6,1.6-4.1,0-5.6 C205.1,224.7,202.6,224.7,201,226.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M201,300.5l-37.9,37.9l-5.6-7.7c-1.3-1.8-3.8-2.2-5.5-0.9c-1.8,1.3-2.1,3.8-0.9,5.5l8.4,11.4 c0.7,0.9,1.7,1.5,2.9,1.6c0.1,0,0.2,0,0.3,0c1.1,0,2.1-0.4,2.8-1.2l41.1-41.1c1.6-1.6,1.6-4.1,0-5.6 C205.1,298.9,202.6,298.9,201,300.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 175.4,
    style: {
      fill: "#84DBFF"
    },
    width: 116.9,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 198.4,
    style: {
      fill: "#84DBFF"
    },
    width: 70.6,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 249.6,
    style: {
      fill: "#84DBFF"
    },
    width: 116.9,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 272.6,
    style: {
      fill: "#84DBFF"
    },
    width: 70.6,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 323.8,
    style: {
      fill: "#84DBFF"
    },
    width: 116.9,
    height: 9.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 346.8,
    style: {
      fill: "#84DBFF"
    },
    width: 70.6,
    height: 9.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.06431c9c5d80bd836a44d158c2588cf5.svg";
export { ForwardRef as ReactComponent };